import { render } from "./App.vue?vue&type=template&id=d778e126"
const script = {}

import "./App.vue?vue&type=style&index=0&id=d778e126&lang=less"

import exportComponent from "../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__